/* global Sys, Services */
Sys.ns("Services");

/**
 * The Clock Service.
 *
 * @class Services.Clock
 * @extends Services.Base
 */
Services.Clock = {
    constructor: function(config) {
        var parsedResponse;

        Services.Clock.superclass.constructor.apply(this, arguments);
        this._timeout = null;
        this._interval = null;
        parsedResponse = config.parsedResponse;
        this._available = false;

        if (config.parsedResponse.g4mode) {
            this._available = true;
        }
        else if (!(typeof parsedResponse.config === "undefined") && !(typeof parsedResponse.config.gameParameters === "undefined")) {
            if (!(typeof parsedResponse.config.gameParameters.clockRequired === "undefined")) {
                this._available = parsedResponse.config.gameParameters.clockRequired;
            }
        }

        this.observable.on({
            "notify:loader.closed": this.setAvailable.bind(this, this._available)
        });
    },

    /**
     * Gets the time.
     *
     * @returns {Date} The time.
     */
    getTime: function() {
        return new Date();
    },

    /**
     * Checks if the clock is available.
     *
     * @returns {boolean} Whether or not the clock is available.
     */
    isAvailable: function() {
        return this._available;
    },

    /**
     * Sets available.
     *
     * @param {boolean} available - If available.
     * @returns {void}
     */
    setAvailable: function(available) {
        this._available = available;
        this._stop();

        if (available) {
            this._start();
        }
    },

    /**
     * Starts sending ticks.
     *
     * @private
     * @returns {void}
     */
    _start: function() {
        var me = this;

        me.publish("tick");

        me._everyMinute(function() {
            me.publish("tick");
        });
    },

    /**
     * Stops sending ticks.
     *
     * @private
     * @returns {void}
     */
    _stop: function() {
        clearTimeout(this._timeout);
        clearInterval(this._interval);

        this._timeout = null;
        this._interval = null;
    },

    /**
     * Calls every minute.
     *
     * @private
     * @param {Function} update - The update function.
     * @returns {void}
     */
    _everyMinute: function(update) {
        var me = this,
            getTimeLeftToStartTimer = function() {
                var now = new Date();

                return (
                    1000 * (59 - now.getSeconds()) +
                    (1000 - now.getMilliseconds())
                );
            },
            callEveryMinute = function() {
                me._interval = setInterval(update, 60000);
            },
            startTimer = function() {
                update();
                callEveryMinute();
            };

        me._timeout = setTimeout(startTimer, getTimeLeftToStartTimer());
    }
};

Services.Clock = Sys.extend(Services.Base, Services.Clock, "Services.Clock");
